import * as THREE from 'three';

export class AimIndicator {
  readonly object3D = new THREE.Group();
  private readonly lineMaterial = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.34,
    depthWrite: false,
  });
  private readonly arrowMaterial = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.58,
    depthWrite: false,
  });
  private readonly line: THREE.Mesh;
  private readonly arrow: THREE.Mesh;

  constructor() {
    this.object3D.name = 'AimIndicator';
    this.line = new THREE.Mesh(new THREE.PlaneGeometry(1, 0.045), this.lineMaterial);
    this.line.name = 'AimIndicatorLine';
    this.line.rotation.x = -Math.PI / 2;
    this.line.position.z = 0.5;
    this.arrow = new THREE.Mesh(new THREE.ConeGeometry(0.24, 0.72, 3), this.arrowMaterial);
    this.arrow.name = 'AimIndicatorArrow';
    this.arrow.rotation.x = Math.PI / 2;
    this.object3D.add(this.line, this.arrow);
  }

  update(
    origin: THREE.Vector3,
    direction: THREE.Vector3,
    isPutting: boolean,
    visible: boolean,
  ): void {
    this.object3D.visible = visible;
    if (!visible) return;
    const length = isPutting ? 5.5 : 18;
    const normalized = direction.clone().setY(0);
    if (normalized.lengthSq() < 0.001) normalized.set(0, 0, 1);
    normalized.normalize();
    this.object3D.position.set(origin.x, origin.y + (isPutting ? 0.025 : 0.08), origin.z);
    this.object3D.rotation.y = Math.atan2(normalized.x, normalized.z);
    this.line.scale.set(0.1, 1, length);
    this.line.position.z = length * 0.5;
    this.arrow.position.set(0, 0, length + 0.18);
    this.arrow.scale.set(isPutting ? 0.7 : 1, isPutting ? 0.35 : 1, isPutting ? 0.7 : 1);
  }

  dispose(): void {
    this.line.geometry.dispose();
    this.arrow.geometry.dispose();
    this.lineMaterial.dispose();
    this.arrowMaterial.dispose();
  }
}
